import { render, staticRenderFns } from "./complianceEvalTableDetailAppr.vue?vue&type=template&id=21b99a04"
import script from "./complianceEvalTableDetailAppr.vue?vue&type=script&lang=js"
export * from "./complianceEvalTableDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b99a04')) {
      api.createRecord('21b99a04', component.options)
    } else {
      api.reload('21b99a04', component.options)
    }
    module.hot.accept("./complianceEvalTableDetailAppr.vue?vue&type=template&id=21b99a04", function () {
      api.rerender('21b99a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/law/complianceEvalTableDetailAppr.vue"
export default component.exports